<div id="filter_overlay"></div>

<div tabindex="=0" (blur)="onTouched()" class="multiselect-dropdown" (clickOutside)="closeDropdown(true)">
  <div [class.disabled]="disabled">
    <span tabindex="-1" class="dropdown-btn" (click)="toggleDropdown($event)">
      <span>{{ _placeholder }}</span>
      <span
        class="selected-item"
        *ngFor="let item of selectedItems; trackBy: trackByFn; let k = index"
        [hidden]="k > _settings.itemsShowLimit - 1"
      >
        {{ item.text }}
        <a style="padding-top: 2px; padding-left: 2px; color: white" (click)="onItemClick($event, item)">x</a>
      </span>
      <span style="float: right !important; padding-right: 4px">
        <!--
        <span style="padding-right: 6px;" *ngIf="itemShowRemaining()>0">+{{itemShowRemaining()}}</span>
-->
        <span [ngClass]="_settings.defaultOpen ? 'dropdown-up' : 'dropdown-down'"></span>
      </span>
    </span>
  </div>
  <div class="dropdown-list" [hidden]="!_settings.defaultOpen">
    <ul class="item1">
      <li
        (click)="toggleSelectAll()"
        *ngIf="
          _data.length > 0 && !_settings.singleSelection && _settings.enableCheckAll && _settings.limitSelection === -1
        "
        class="multiselect-item-checkbox"
        style="border-bottom: 1px solid #ccc; padding: 10px"
      >
        <input
          type="checkbox"
          aria-label="multiselect-select-all"
          [checked]="isAllItemsSelected()"
          [disabled]="disabled || isLimitSelectionReached()"
        />
        <div>{{ !isAllItemsSelected() ? _settings.selectAllText : _settings.unSelectAllText }}</div>
      </li>
      <li class="filter-textbox" *ngIf="_data.length > 0 && _settings.allowSearchFilter">
        <input
          type="text"
          aria-label="multiselect-search"
          [readOnly]="disabled"
          [placeholder]="_settings.searchPlaceholderText"
          [(ngModel)]="filter.text"
          (ngModelChange)="onFilterTextChange($event)"
        />
        <i class="material-icons">{{ 'search' | translate }}</i>
      </li>
    </ul>
    <div class="cb-blk-wrap dd_option__m">
      <div *ngFor="let colindex of optionColumnLength">
        <ul class="item2">
          <!-- <div *ngFor="let group of groupedData let j = index;">
                     <label>{{group.name}}</label>-->
          <label class="fltr-itm-group-hdr Regular14" *ngIf="relatedIndex === 0 && colindex === 0"
            >Based on Selection</label
          >
          <div
            *ngFor="
              let item of _data | multiSelectFilter: filter | slice: colindex * 10:colindex * 10 + 10;
              let i = index
            "
          >
            <li *ngIf="item.related" (click)="onItemClick($event, item)" class="multiselect-item-checkbox">
              <div class="dd-list-row">
                <div class="dd-list-block">
                  <input
                    type="checkbox"
                    aria-label="multiselect-item"
                    [class.disabled-selected]="disabled"
                    [checked]="isSelected(item)"
                    [disabled]="disabled || (isLimitSelectionReached() && !isSelected(item)) || item.isDisabled"
                  />
                  <div>{{ item.text }}</div>
                </div>
              </div>
            </li>
            <label
              class="fltr-itm-group-hdr Regular14"
              *ngIf="unrelatedIndex === i && unrelatedmodules === colindex && unrelatedIndex !== 0"
              >{{ 'All' | translate }}</label
            >
            <label class="fltr-itm-group-hdr Regular14" *ngIf="unrelatedIndex === 0 && colindex === 0 && i === 0">{{
              'All' | translate
            }}</label>
            <li *ngIf="!item.related" (click)="onItemClick($event, item)" class="multiselect-item-checkbox">
              <div class="dd-list-row">
                <div class="dd-list-block">
                  <input
                    type="checkbox"
                    aria-label="multiselect-item"
                    [class.disabled-selected]="disabled"
                    [checked]="isSelected(item)"
                    [disabled]="disabled || (isLimitSelectionReached() && !isSelected(item)) || item.isDisabled"
                  />
                  <div>{{ item.text }}</div>
                </div>
              </div>
            </li>
          </div>
          <li class="no-data" *ngIf="_data.length === 0">
            <h5>{{ _settings.noDataAvailablePlaceholderText }}</h5>
          </li>
          <!--  </div>-->
        </ul>
      </div>

      <!--   <ul class="item2" [style.maxHeight]="_settings.maxHeight+'px'">
        <li *ngFor="let item of _data | multiSelectFilter:filter; let i = index;" (click)="onItemClick($event,item)" class="multiselect-item-checkbox">
          <div class="dd-list-row">
            <div class="dd-list-block">
              <input type="checkbox" aria-label="multiselect-item" [class.disabled-selected]="disabled"
                     [checked]="isSelected(item)" [disabled]="disabled || (isLimitSelectionReached() && !isSelected(item)) || item.isDisabled" />
              <div>{{item.text}}{{item.related}}</div>
            </div>
          </div>
        </li>
        <li class='no-data' *ngIf="_data.length == 0">
          <h5>{{_settings.noDataAvailablePlaceholderText}}</h5>
        </li>
      </ul>

      <ul class="item2" [style.maxHeight]="_settings.maxHeight+'px'">
        <li *ngFor="let item of _data | multiSelectFilter:filter; let i = index;" (click)="onItemClick($event,item)" class="multiselect-item-checkbox">
          <div class="dd-list-row">
            <div class="dd-list-block">
              <input type="checkbox" aria-label="multiselect-item" [class.disabled-selected]="disabled"
                     [checked]="isSelected(item)" [disabled]="disabled || (isLimitSelectionReached() && !isSelected(item)) || item.isDisabled" />
              <div>{{item.text}}{{item.related}}</div>
            </div>
          </div>
        </li>
        <li class='no-data' *ngIf="_data.length == 0">
          <h5>{{_settings.noDataAvailablePlaceholderText}}</h5>
        </li>
      </ul>

      <ul class="item2" [style.maxHeight]="_settings.maxHeight+'px'">
        <li *ngFor="let item of _data | multiSelectFilter:filter; let i = index;" (click)="onItemClick($event,item)" class="multiselect-item-checkbox">
          <div class="dd-list-row">
            <div class="dd-list-block">
              <input type="checkbox" aria-label="multiselect-item" [class.disabled-selected]="disabled"
                     [checked]="isSelected(item)" [disabled]="disabled || (isLimitSelectionReached() && !isSelected(item)) || item.isDisabled" />
              <div>{{item.text}}{{item.related}}</div>
            </div>
          </div>
        </li>
        <li class='no-data' *ngIf="_data.length == 0">
          <h5>{{_settings.noDataAvailablePlaceholderText}}</h5>
        </li>
      </ul>

      <ul class="item2" [style.maxHeight]="_settings.maxHeight+'px'">
        <li *ngFor="let item of _data | multiSelectFilter:filter; let i = index;" (click)="onItemClick($event,item)" class="multiselect-item-checkbox">
          <div class="dd-list-row">
            <div class="dd-list-block">
              <input type="checkbox" aria-label="multiselect-item" [class.disabled-selected]="disabled"
                     [checked]="isSelected(item)" [disabled]="disabled || (isLimitSelectionReached() && !isSelected(item)) || item.isDisabled" />
              <div>{{item.text}}{{item.related}}</div>
            </div>
          </div>
        </li>
        <li class='no-data' *ngIf="_data.length == 0">
          <h5>{{_settings.noDataAvailablePlaceholderText}}</h5>
        </li>
      </ul>-->
    </div>

    <!-- <div class="dd_action_buttons">
      <div style="border-width: 1px 1px 0 0">Close</div>
      <div (click)="closeDropdown()" style="color: #0069d1; border-width: 1px 0 0 1px">Apply</div>
    </div> -->
  </div>
</div>
